import React, {FC, useEffect, useRef, useState} from "react"
import PaymentForm from "@irati-web/payments/src/components/PaymentForm"
import {Topup} from "@irati/types"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"

interface Props {
  finalCost: number
  rewardWalletTopup: Topup
  getTopupStatus: () => void
  getPaymentRedirectUrl: () => void
  createTopUp: () => Promise<void>
}

const READY = "ready"

const PayByCard: FC<Props> = ({rewardWalletTopup, getTopupStatus, getPaymentRedirectUrl, createTopUp, finalCost}) => {
  const mounted = useRef(true)
  const [status, setStatus] = useState<string>("idle")

  useEffect(() => {
    setStatus("loading")
    const loadTopUp = async () => {
      if (mounted.current) {
        await createTopUp()
        setStatus(READY)
      }
    }

    loadTopUp()
    tracking.payByCard()

    return () => {
      mounted.current = false
    }
  }, [])

  return status === READY ? (
    <PaymentForm
      paymentOrder={rewardWalletTopup.paymentOrder}
      amount={finalCost}
      onComplete={getTopupStatus}
      redirectReturnUrl={getPaymentRedirectUrl}
    />
  ) : (
    <Loading load={hangPromise()} />
  )
}

export default PayByCard
